'use client';

import { Box, Image } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { ProductUIFrameBackground } from 'components/product-ui/product-ui-frame-background/product-ui-frame-background';
import { useLocale } from 'next-intl';
import css from './hero.module.css';
export function IllustrationScene() {
  const locale = useLocale();
  const {
    t,
    i18n
  } = useTranslation(locale, 'home-teams');
  return <Box className={css.imageContainer} data-sentry-element="Box" data-sentry-component="IllustrationScene" data-sentry-source-file="illustration-scene.tsx">
            <ProductUIFrameBackground className={css.backgroundImage} data-sentry-element="ProductUIFrameBackground" data-sentry-source-file="illustration-scene.tsx" />
            <Image className={cn(css.foregroundImage, css.desktop)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/intro/wide/headerui.${i18n.language}.png`} width={1312} height={738} alt={t('heroAlt')} priority data-sentry-element="Image" data-sentry-source-file="illustration-scene.tsx" />
            <Image className={cn(css.foregroundImage, css.mobile)} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home-teams/intro/narrow/headerui.${i18n.language}.png`} width={500} height={466} alt={t('heroAltMobile')} priority data-sentry-element="Image" data-sentry-source-file="illustration-scene.tsx" />
        </Box>;
}